<template>
  <v-dialog v-model="dialog" persistent width="290px">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-bind="{ ...attrs, ...textFieldProps }"
        v-on="on"
        :prepend-inner-icon="textFieldProps.prependInnerIcon"
        readonly
        :value="dateRangeText"
        :label="label"
        clearable
        @click:clear="handleClear"
        hide-details="true"
        dense
      />

    </template>
    <v-date-picker
      v-model="localValue"
      range
      scrollable
      @change="handleDateChange"
      :min="minDateComputed"
      :max="maxDateComputed"
      v-bind="pickerProps"
    >
      <v-spacer />
      <v-btn text color="primary" @click="handleCancel">Cancel</v-btn>
      <v-btn text color="primary" @click="handleDateConfirm">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
import { getTommorowDate } from '../../../../lib/helpers';

export default {
  name: "DateRangeFilter",
  props: {
    value: {
      type: Array || String,
      default: () => [] || "",
    },
    label: {
      type: String,
      default: "Select Date Range",
    },
    includeToday: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: String,
      default: "",
    },
    minDateOffset: {
      type: Number,
      default: null,
    },
    textFieldProps: {
      type: Object,
      default: () => ({}),
    },
    pickerProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialog: false,
      localValue: [...this.value],
      getTommorowDate,
    };
  },
  watch: {
    value(newVal) {
      this.localValue = [...newVal];
    },
  },
  computed: {
    dateRangeText() {
      if (this.localValue.length > 0) {
        const [start, end] = this.localValue;
        return `${start} - ${end || start}`;
      }
      return "";
    },
    maxDateComputed() {
      if (this.maxDate) return this.maxDate;

      const today = new Date();
      const localDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

      return this.includeToday
        ? localDate
        : getTommorowDate(-1); 
    },
    minDateComputed() {
      if (this.minDate) return this.minDate;
      if (this.minDateOffset !== null) {
        const date = new Date();
        date.setDate(date.getDate() - this.minDateOffset);
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      }
      return null;
    },
  },
  methods: {
    clearError() {
      if (this.errorMessages) {
        this.$emit("clear-error");
      }
    },
    handleClear() {
      this.localValue = [];
      this.$emit("input", []);
    },
    handleDateChange(date) {
      if (date.length === 1) {
        this.localValue = [date[0], date[0]];
      } else {
        this.localValue = date;
      }
    },
    handleDateConfirm() {
      if (this.localValue.length === 2) {
        const [start, end] = this.localValue;
        this.localValue = start <= end ? [start, end] : [end, start];
      }
      if (this.localValue.length === 1) {
        this.localValue = [this.localValue[0], this.localValue[0]];
      }
      this.clearError();
      this.$emit("input", [...this.localValue]);
      this.dialog = false;
    },
    handleCancel() {
      this.localValue = [];
      this.$emit("input", []); 
      this.dialog = false;
    },
  },
};
</script>
